import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

const RecentlyUpdatedSlugs = [
  'google-data-analytics',
  'google-digital-marketing-ecommerce',
  'google-it-automation',
  'google-it-support',
  'google-project-management',
  'google-ux-design',
  'google-business-intelligence',
  'google-cybersecurity',
];

export const isPartOfRecentlyUpdatedBadgeExperiment = () =>
  GrowthDiscoveryExperiments.get('showRecentlyUpdatedBadge') === true;

export const shouldShowRecentlyUpdatedBadge = (slug: string) => {
  return isPartOfRecentlyUpdatedBadgeExperiment() && RecentlyUpdatedSlugs.includes(slug);
};
